import { gql } from "@apollo/client";

export const UPDATE_DISFAGIA = gql`
    mutation UpdateDisfagia(
        $input: AddDisfagiaRIInput!
        $screen: Int!
        )
    {
        createAndUpdateDisfagiaRI(
            screen: $screen
            input: $input
        ){
            idDisfagiaRI
        }
    }
`;